/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

export interface IPublicError {
	message: string;
	traceId?: string;
	data?: Record<string, unknown>;
	code?: string;
	explanation?: string;
	action?: string;
}

export default class CKEditorCloudServicesServerError extends Error {
	public readonly code?: string;

	public readonly traceId?: string;

	public readonly data?: Record<string, unknown>;

	private constructor( message: string, error: IPublicError ) {
		super();

		this.name = 'CKEditorCloudServicesServerError';
		this.stack = undefined;
		this.message = message;
		this.code = error.code;
		this.traceId = error.traceId;
		this.data = error.data;
	}

	public static fromPublicError( publicError: IPublicError ): CKEditorCloudServicesServerError {
		return new CKEditorCloudServicesServerError( _formatMessage( publicError ), publicError );
	}
}

function _formatMessage( publicError: IPublicError ): string {
	let errorMessage: string = `cloud-services-server-error: ${ publicError.message }`;

	if ( publicError.explanation ) {
		errorMessage += `\nExplanation: ${ publicError.explanation }`;
	}

	if ( publicError.action ) {
		errorMessage += `\nAction: ${ publicError.action }`;
	}

	if ( publicError.traceId ) {
		errorMessage += `\nTraceId: ${ publicError.traceId }`;
	}

	if ( publicError.code ) {
		errorMessage += `\nCode: ${ publicError.code }`;
	}

	return errorMessage;
}
